import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Zoid from 'common/modules/zoid'

import Overlay from './Overlay'

class Prompt extends React.Component {
    constructor() {
        super()

        this.state = {
            initialized: false,
        }

        window.document.title = 'Prompt'
    }

    componentDidMount() {
        const { init } = this.props

        init({
            payload: {
                pathname: '/prompt',
            },
        })
    }

    componentDidUpdate() {
        const { initialized } = this.state
        const { xpropsLoaded } = this.props

        if (xpropsLoaded && !initialized) {
            this.setInitialized(true)
        }
    }

    setInitialized = (isInitialized, callback = () => {}) => {
        this.setState({
            initialized: isInitialized,
        }, callback)
    }

    render() {
        const { initialized } = this.state

        if (!initialized) {
            return null
        }

        return (
            <Overlay />
        )
    }
}

Prompt.defaultProps = {
    init: null,
}

Prompt.propTypes = {
    init: PropTypes.func,
    xpropsLoaded: PropTypes.bool.isRequired,
}

const mapStateToProps = (state) => ({
    xpropsLoaded: Zoid.selectors.xpropsLoaded(state),
})

const actionCreators = {
    init: Zoid.creators.init,
}

export default connect(
    mapStateToProps,
    actionCreators,
)(Prompt)
